
export const MAX_TRANSIENT_REFRESH_FAILURES = 10;

function jwtExp(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const exp = (JSON.parse(atob(base64)) as { exp?: unknown }).exp;
    return typeof exp === 'number' ? exp : null;
  } catch {
    return null;
  }
}

export function isSessionDead(
  refreshToken: string | null | undefined,
  transientFailures: number,
  nowMs: number = Date.now(),
): boolean {
  if (!refreshToken) return true;
  const exp = jwtExp(refreshToken);
  if (exp !== null && exp * 1000 <= nowMs) return true;
  return transientFailures >= MAX_TRANSIENT_REFRESH_FAILURES;
}
